// extracted by mini-css-extract-plugin
export var centerText = "_7e-8";
export var container = "_7e-0";
export var doughnutContainer = "_7e-7";
export var legend = "_7e-a";
export var legendItemColorDisplay = "_7e-b";
export var legendItemLabel = "_7e-d";
export var legendItemValue = "_7e-c";
export var lg = "_7e-5";
export var maxWidth = "_7e-9";
export var md = "_7e-4";
export var responsive = "_7e-6";
export var sm = "_7e-3";
export var xs = "_7e-2";
export var xxs = "_7e-1";